module.exports = __webpack_public_path__ + "img/juhe_bg.b3b8b427.png";